import { NgModule } from '@angular/core';
import { ClipboardModule } from '@angular/cdk/clipboard';

import { CopyDirective } from './copy.directive';

@NgModule({
  declarations: [CopyDirective],
  imports: [ClipboardModule],
  exports: [CopyDirective]
})
export class CopyModule { }
